/** @jsx _j **/

/** @jsxFrag _f **/
var _require = require('astroturf'),
    _j = _require.jsx,
    _f = _require.F;
/* eslint-disable import/no-cycle */


import { MDXRenderer } from 'gatsby-plugin-mdx';

var JsDocDescription = function JsDocDescription(_ref) {
  var definition = _ref.definition;
  var description = definition.description || definition.type && definition.type.typeDef;
  if (!description) return null;
  return _j("div", {
    css: [require("./JsDocDescription-CssProp1_div.module.css"), []]
  }, _j(MDXRenderer, null, description.childMdx.body));
};

export default JsDocDescription;
export var fragment = "3451605316";